import React from "react";
import { Loader } from "@progress/kendo-react-indicators";
import { Button } from "@progress/kendo-react-buttons";
const SubmitButton = ({
  isLoading = false,
  disabled = false,
  children,
  className,
  type = "submit",
  loaderSize = "small",
  loaderType = "infinite-spinner",
  loaderClassName = "text-white",
  ...buttonProps
}) => {
  return (
    <Button
      type={type}
      className={`${className} common-btn`}
      disabled={isLoading || disabled}
      {...buttonProps}
    >
      {isLoading ? (
        <>
          <Loader
            size={loaderSize}
            type={loaderType}
            className={loaderClassName}
          />
        </>
      ) : (
        children
      )}
    </Button>
  );
};

export default SubmitButton;
